function get(key) {
  const authCache = sessionStorage.getItem(key);
  if (authCache) return JSON.parse(authCache);
}

function set(key, data) {
  sessionStorage.setItem(key, JSON.stringify(data));
}

function reset(key) {
  sessionStorage.removeItem(key);
}

export default {
  get,
  set,
  reset,
};
